// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Header_textarea__3dCsE","ceil":"Header_ceil__1s_2w","deleteButton":"Header_deleteButton__2gEcv"};